let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("04Anh")).then(() => parcelRequire('5bJ4j'));